<script setup lang="ts">
import { Tooltip } from "@soft-db/ui";

defineProps<{
	data: string;
	saturated?: boolean;
}>();

const { t } = useI18n();
</script>

<template>
	<Tooltip :disabled="!saturated" :tooltip="t('dashboard.dataSaturated')">
		<div class="indicator">
			<span v-if="saturated" class="indicator-item -translate-y-1 translate-x-[2px]">*</span>
			<div class="mr-1">{{ data }}</div>
		</div>
	</Tooltip>
</template>
